import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import FeatherIcon from 'feather-icons-react'
import DeletePopup from '../../component/deletePopup'
import Pagination from '../../component/common/pagination'
import { SpinnerContext } from '../../context/spinnerContext'
import { deleteNotification, getNotification, readAllNotification } from '../../redux/slices/notificationSlice'
import { checkIfPastDate, formatTimeAgo } from '../../helper/function'
import StatusModal from '../../component/modal/statusModal'
import ScheduledModalContent from '../../component/scheduleStatus/scheduledModalContent'
import CancelModalContent from '../../component/scheduleStatus/canceleModalContent'
import { getSchedulePropertyDataById } from '../../redux/slices/propertySlice'
import { PreviewImg } from '../../helper/imagepath'

const Notification = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { changeLoader } = useContext(SpinnerContext)
  const { allNotification } = useSelector(({ notification }) => notification)

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [currentPage, setCurrentPage] = useState(allNotification?.currentPage || 1)
  const [itemsPerPage] = useState(allNotification?.limit || 6)
  const [notificationID, setNotificationID] = useState(null)
  const [isRefresh, setIsRefresh] = useState(true)
  const [loader, setLoader] = useState(false)
  const { scheduledProperties } = useSelector((state) => state.property)
  const toggleDeleteModal = () => setIsDeleteModalOpen((prev) => !prev)

  const [chatUserId, setChatUserId] = useState(null)
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false)
  const [modalName, setModalName] = useState(null)

  const clientName = useMemo(
    () =>
      scheduledProperties?.getPropertyScheduleData?.properties?.client
        ? scheduledProperties?.getPropertyScheduleData?.properties?.client?.first_name +
          ' ' +
          scheduledProperties?.getPropertyScheduleData?.properties?.client?.last_name
        : '',
    [scheduledProperties?.getPropertyScheduleData]
  )

  const CheckTimeOver = useMemo(() => {
    return scheduledProperties?.getPropertyScheduleData?.next_checkin_time
      ? checkIfPastDate(scheduledProperties?.getPropertyScheduleData?.next_checkin_time, false)
      : checkIfPastDate(scheduledProperties?.getPropertyScheduleData?.booking_date_time, true)
  }, [scheduledProperties?.getPropertyScheduleData?.booking_date_time, scheduledProperties?.getPropertyScheduleData?.next_checkin_time])

  const handlePagination = async () => {}

  const getPropertyData = async (schedule_id, status) => {
    changeLoader(true)
    await dispatch(getSchedulePropertyDataById(schedule_id))
      .then(() => {
        setIsStatusModalOpen(true)
        setModalName(status)
        changeLoader(false)
      })
      .catch(() => {
        changeLoader(false)
      })
  }
  const handleNotificationClick = (e, notification) => {
    e.preventDefault()

    const { operation, propertySchedule, cleanings, schedule_cleaners, cleaning_reviews, properties, reference_id } = notification

    // Helper function for navigation
    const navigateToCleaningDetail = (property_schedule_id) => {
      navigate(`/overview/complete-cleaning/${property_schedule_id}/cleaningDetail`)
    }

    // Helper function for fetching property data
    const handlePropertyData = (property_schedule, booking_status) => {
      if (['scheduled', 'canceled', 'in progress', 'canceled cleaner'].includes(booking_status)) {
        getPropertyData(property_schedule.property_schedule_id, booking_status)
      } else if (booking_status === 'completed') {
        navigateToCleaningDetail(property_schedule.property_schedule_id)
      }
    }
    switch (operation) {
      case 'New client registered':
        navigate(`/clients/clientInfo/${notification?.client?.client_id}`)
        break
      case 'New property created':
        navigate(`/clients/clientInfo/${properties?.properties_client?.client_id}`)
        break
      case 'Cleaning is complete':
        navigateToCleaningDetail(cleanings?.property_schedule?.property_schedule_id)
        break
      case 'New property cleaning schedule created':
      case 'Cleaner assigned to property cleaning request':
      case 'Property cleaning schedule updated':
      case 'Property cleaning schedule canceled':
      case 'Property cleaning schedule canceled by the cleaner':
      case 'Cancellation charge request accepted':
      case 'Cancellation charge request declined':
      case 'New cleaning report created':
      case 'Cleaner is unavailable':
        setChatUserId(propertySchedule?.property_schedule_id)
        handlePropertyData(propertySchedule, propertySchedule?.booking_status)
        break
      case 'New Cleaning Review is Create':
        navigateToCleaningDetail(cleaning_reviews?.cleaning_reviews_propertySchedule?.property_schedule_id)
        break
      case 'Cleaning is start':
        setChatUserId(cleanings?.property_schedule?.property_schedule_id)
        handlePropertyData(cleanings?.property_schedule, cleanings?.property_schedule?.booking_status)
        break

      case 'Cleaning request accepted':
      case 'Cleaning request declined':
        setChatUserId(schedule_cleaners?.schedule_cleaners_propertySchedule?.property_schedule_id)
        handlePropertyData(
          schedule_cleaners?.schedule_cleaners_propertySchedule,
          schedule_cleaners?.schedule_cleaners_propertySchedule?.booking_status
        )
        break
      case 'New cleaner registered':
        navigate(`/cleaners/cleaners-info/${reference_id}`)
        break
      default:
        console.warn('Unhandled operation:', operation)
    }
  }

  const handlePageChange = (selectedItem) => {
    setCurrentPage(selectedItem.selected + 1)
    setIsRefresh(true)
  }

  const handleDelete = (id) => {
    setNotificationID(id)
    toggleDeleteModal()
  }

  const confirmDelete = () => {
    if (!notificationID) return
    changeLoader(true)
    dispatch(deleteNotification(notificationID))
      .then((response) => {
        if (response?.payload?.status === 200) {
          setIsRefresh(true)
          if (allNotification?.notifications?.length === 1) {
            setCurrentPage((prev) => prev - 1)
          }
        }
      })
      .finally(() => {
        changeLoader(false)
        setIsDeleteModalOpen(false)
      })
  }

  useEffect(() => {
    if (!isRefresh) {
      return
    }
    const params = { page: currentPage, limit: itemsPerPage, isPagination: true }
    changeLoader(true)
    setLoader(true)
    dispatch(getNotification(params)).finally(() => {
      changeLoader(false)
      setTimeout(() => {
        setLoader(false)
      }, 1000)
      setIsRefresh(false)
    })
  }, [currentPage, itemsPerPage, isRefresh])

  useEffect(() => {
    dispatch(readAllNotification())
  }, [])

  return (
    <div className="page-wrapper noti-main">
      <div className="content">
        <div className="page-header">
          <div className="content-page-header">
            <h5>Notification</h5>
          </div>
        </div>
        {allNotification?.totalRecords > 0 ? (
          <div className="">
            {allNotification?.notifications?.map((notification) => (
              <>
                <div className="notification_card_sec" key={notification?.notification_id} onClick={(e) => handleNotificationClick(e, notification)}>
                  <div className="notification_card_personal_info">
                    <img className="notification_user_img" src={PreviewImg || notification?.userImage} alt="Notification User" />
                    <div className="notification_card_text">
                      <h4 className="notification_user_name">{notification?.subject}</h4>
                      <p className="notification_user_info">{notification?.body}</p>
                      <h6 className="notification_time">
                        <span>
                          {/* {convertTimestampToDate(notification?.created_at)} | {convertTimestampToTime(notification?.created_at)} */}
                          {formatTimeAgo(notification?.created_at)}
                        </span>
                      </h6>
                    </div>
                  </div>
                  <div className="notification_card_timimng_info">
                    <Link
                      className="btn-action-icon delete_icon_div border-5"
                      style={{ borderRadius: '50%' }}
                      onClick={(e) => {
                        e.stopPropagation()
                        handleDelete(notification?.notification_id)
                      }}
                    >
                      <i className="fe fe-trash-2">
                        <FeatherIcon icon="trash-2" color="red" />
                      </i>
                    </Link>
                  </div>
                </div>
              </>
            ))}
          </div>
        ) : (
          !loader && (
            <div className="common_card_div">
              <p style={{ textAlign: 'center' }}>No Notification Found</p>
            </div>
          )
        )}

        {allNotification?.totalRecords > 0 && (
          <div className="row">
            <div className="col-12 pagination_main_div mt-5">
              <Pagination
                currentPage={currentPage}
                onPageChange={handlePageChange}
                totalPages={allNotification?.totalPage || 0}
                itemsPerPage={itemsPerPage}
              />
            </div>
          </div>
        )}

        {isDeleteModalOpen && (
          <DeletePopup isDeleteModalOpen={isDeleteModalOpen} toggle={toggleDeleteModal}>
            <div className="multi_btn_div">
              <button type="button" className="btn common-outline-btn w-100" onClick={toggleDeleteModal}>
                Cancel
              </button>
              <button type="button" className="btn btn-danger common-field-btn w-100" onClick={confirmDelete}>
                Delete
              </button>
            </div>
          </DeletePopup>
        )}

        {/* Modal open */}
        {isStatusModalOpen && (
          <StatusModal
            onClose={() => setIsStatusModalOpen(false)}
            title={`Cleaning #${scheduledProperties?.getPropertyScheduleData?.schedule_number}`}
            headerContent={{
              name: clientName,
              status: scheduledProperties?.getPropertyScheduleData?.booking_status
            }}
            chatUserId={chatUserId}
            CheckTimeOver={CheckTimeOver}
            clientId={scheduledProperties?.getPropertyScheduleData?.properties?.client?.client_id}
          >
            {['canceled', 'canceled cleaner']?.includes(modalName) && (
              <CancelModalContent
                data={scheduledProperties?.getPropertyScheduleData}
                finalAmount={scheduledProperties?.finalAmount}
                onClose={() => setIsStatusModalOpen(false)}
              />
            )}
            {['scheduled', 'in progress']?.includes(modalName) && (
              <ScheduledModalContent
                data={scheduledProperties?.getPropertyScheduleData}
                setIsRefresh={setIsRefresh}
                onClose={() => setIsStatusModalOpen(false)}
                handlePagination={handlePagination}
                page={`overview`}
              />
            )}
          </StatusModal>
        )}
      </div>
    </div>
  )
}

export default Notification
